import { useEffect } from 'react';
import { useElementSize } from '@fiverr-private/hooks';
import { theme } from '@fiverr-private/theme';
import type { ModalProps } from '../../types';

const DEFAULT_FULL_SCREEN_BREAKPOINT = 'md' satisfies ModalProps['fullScreenBreakpoint'];

const getFullscreenBreakpoint = ({ fullScreenBreakpoint, mobileFullScreen }) => {
    if (fullScreenBreakpoint !== undefined) {
        return fullScreenBreakpoint;
    }
    if (mobileFullScreen !== undefined) {
        return mobileFullScreen ? DEFAULT_FULL_SCREEN_BREAKPOINT : 'none';
    }

    return DEFAULT_FULL_SCREEN_BREAKPOINT;
};

const isFullscreenActive = ({ breakpoint, windowWidth }) => {
    const breakpoints = theme.numericBreakpoints;

    if (breakpoint === 'none') {
        return false;
    }
    if (breakpoint === 'all') {
        return true;
    }
    if (breakpoint === 'sm' && windowWidth < breakpoints.sm) {
        return true;
    }
    if (breakpoint === 'md' && windowWidth < breakpoints.md) {
        return true;
    }

    return false;
};

export const useIsFullscreen = (
    fullScreenBreakpoint?: ModalProps['fullScreenBreakpoint'],
    mobileFullScreen?: ModalProps['mobileFullScreen']
) => {
    useEffect(() => {
        if (mobileFullScreen !== undefined) {
            // eslint-disable-next-line no-console
            console.warn(
                'Modal: The mobileFullScreen prop is deprecated, please use the fullScreenBreakpoint prop instead'
            );
        }
    }, [mobileFullScreen]);

    const breakpoint = getFullscreenBreakpoint({ fullScreenBreakpoint, mobileFullScreen });
    const { width: windowWidth } = useElementSize(typeof window !== 'undefined' ? window : null);

    return isFullscreenActive({ breakpoint, windowWidth });
};
